const doc = [({"en":({"js":({"sessions":({"new":({"uni_login_image_button":({"login_with_uni_login":"Login with UNI-C"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;